import React from "react";
import noJob from "../../../../assets/Illustrations/noStudents.svg";

function NoStudents({ setCreateBatchFlag }) {
  return (
    <div className="text-center mt-[1rem]">
      <img src={noJob} width={240} className="mx-auto" alt="" />
      <p className="sub-text-color text-[.94rem] mt-4 max-w-[500px] mx-auto">
        No students added yet.
      </p>
      {/* <button
        onClick={() => setCreateBatchFlag(true)}
        className="btn-orange mt-3 rounded-lg px-4 py-[.4rem] text-[.9rem]"
      >
        + Add Student
      </button> */}
    </div>
  );
}

export default NoStudents;
